<template>
  <fragment>
    <!-- <template v-if="buttonType === 2 || buttonType == 3"> -->
      <ul
        v-show="visible"
        :style="{ left: left + 'px', top: top - 50 + 'px' }"
        class="contextmenu"
      >
        <template v-for="(item, index) in tableButtons">
          <li
            :key="index"
            @click="buttonClick(item.method)"
          >
            {{ item.name }}
          </li>
        </template>
      </ul>
    <!-- </template> -->
    <!-- <template v-if="buttonType === 1 || buttonType == 3"> -->
      <!-- <el-button-group class="button-group"> -->
      <template v-for="(item, index) in menuButtons">
        <el-button
          type="primary"
          :class="'icon '+item.icon"
          :key="index"
          @click="buttonClick(item.method)"
          >{{ item.name }}</el-button
        >
      </template>

      <slot name="toolbar"></slot>
      <!-- </el-button-group> -->
    <!-- </template> -->
  </fragment>
</template>

<script>
export default {
  name: "PageButton",
  props: {
    position: {
      type: Object,
      default: () => {
        return { clientY: 0, clientX: 0 };
      },
    },
    menuHideRules: { type: Array, default: () => [] },
    hideRules: { type: Array, default: () => [] },
    extendOption: { type: Array, default: () => [] },
    groupName: { type: String, default: "" },
  },

  data() {
    return {
      authButtons: [],
      // authButtons: [
      //   // { name: "刷新", url: "",method: "refsh",icon: "el-icon-refresh",},
      //   {
      //     name: "新增",
      //     url: "",
      //     method: "add",
      //     icon: "el-icon-circle-plus-outline",
      //   },
      //   { name: "修改", url: "", method: "update", icon: "el-icon-edit" },
      //   { name: "删除", url: "", method: "del", icon: "el-icon-delete" },
      // ],
      buttonType: 3,
      visible: false,
      top: 0,
      left: 0,
    };
  },
  watch: {
    position(e) {
      let screenX = window.innerWidth;
      if (screenX - e.clientX < 100) this.left = e.clientX - 100;
      else this.left = e.clientX + 10;
      this.top = e.clientY;
      this.visible = true;
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.close);
      } else {
        document.body.removeEventListener("click", this.close);
      }
    },
  },

  computed: {
    
    menuButtons() {
      return this.authButtons.filter((item) => {
        return item.MenuType === 1 || item.MenuType === 2;
      });
    },
    tableButtons() {
      return this.authButtons.filter((item) => {
        return item.MenuType === 3 || item.MenuType === 2;
      });
    },
  },
  mounted() {
    this.loadAuthButtons();
    this.authButtons = [...this.authButtons, ...this.extendOption];
    // this.menuHideRules.forEach((item, index) => {
    //   this.authButtons.forEach((j, k) => {
    //     if (item == j.method) {
    //       j.menuHide = true;
    //     }
    //   });
    // });
    // this.hideRules.forEach((item, index) => {
    //   this.authButtons.forEach((j, k) => {
    //     if (item == j.method) {
    //       j.hide = true;
    //     }
    //   });
    // });
  },
  methods: {
    loadAuthButtons() {
      let buttons = [];
      let AuthButtons = [...this.$store.state.permission.authButtons];
      if (this.groupName) {
        AuthButtons = AuthButtons.filter(
          (item) => item.GroupName === this.groupName
        );
      }
      AuthButtons.forEach((item) => {
        buttons.push({
          name: item.Name,
          method: item.ActionFlag,
          icon: item.IconCls,
          MenuType:item.MenuType
        });
      });
      this.authButtons = buttons;
    },
    buttonClick(method) {
      this.$emit(method);
    },

    close() {
      this.visible = false;
    },
  },
};
</script>


<style   lang="scss" scoped>
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 100;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PageButton/index.vue